import { lazy } from 'react';
import { useSelector } from 'react-redux';
import AppRoutePrivate from './AppRoutePrivate';
import UserActions from '../actions/UserActions';
import MainLayout from '../layouts/mainLayout/MainLayout';
import { Routes, Route, Navigate } from 'react-router-dom';
import BlankLayout from '../layouts/blankLayout/BlankLayout';
import OutsideLayout from '../layouts/outsideLayout/OutsideLayout';
import BlockedLayout from '../layouts/blockedLayout/BlockedLayout';
import SettingsLayout from '../layouts/settingsLayout/SettingsLayout';
import AnalyticsLayout from '../layouts/analyticsLayout/AnalyticsLayout';
import { LoadingProvider } from '../layouts/outsideLayout/LoadingContext';
// import ConsoleLogActions from "../actions/ConsoleLogActions";

const Login = lazy(() => import('../pages/users/login/Login'));
const LoginMagic = lazy(() => import('../redirects/LoginMagic'));
const RegistrationPage = lazy(
  () => import('../pages/users/registration/RegistrationPage')
);
const PolicyList = lazy(() => import('../pages/policy/PolicyList'));
const PolicyEdit = lazy(() => import('../pages/policy/PolicyEdit'));
const ForgotPasswordPage = lazy(
  () => import('../pages/users/forgotPassword/ForgotPasswordPage')
);
const ForgotPasswordSetNewPassword = lazy(
  () => import('../pages/users/forgotPassword/ForgotPasswordSetNewPassword')
);
const InvoicePaymentSuccess = lazy(
  () => import('../redirects/invoicePayment/InvoicePaymentSuccess')
);
const InvoicePaymentFail = lazy(
  () => import('../redirects/invoicePayment/InvoicePaymentFail')
);
const PayIdramSuccess = lazy(
  () => import('../redirects/idram/PayIdramSuccess')
);
const InventoryQuantityImport = lazy(
  () =>
    import('../pages/inventory/inventoryProductQuantities/inventoryProductQuantityImport/InventoryQuantityImport')
);
const PayIdramFail = lazy(() => import('../redirects/idram/PayIdramFail'));
const ArcaPayApiCheck = lazy(() => import('../redirects/ArcaPayApiCheck'));
const UserEmailConfirm = lazy(() => import('../redirects/UserEmailConfirm'));
const Test = lazy(() => import('../pages/Test'));
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));
const OrderList = lazy(() => import('../pages/orders/orderList/OrderList'));
const OrderProducts = lazy(
  () => import('../pages/orders/orderProducts/OrderProducts')
);
const OrderView = lazy(() => import('../pages/orders/orderView/OrderView'));
const PaymentList = lazy(
  () => import('../pages/payments/paymentList/PaymentList')
);
const PaymentEdit = lazy(
  () => import('../pages/payments/paymentEdit/PaymentEdit')
);
const VisitList = lazy(() => import('../pages/visits/visitList/VisitList'));
const VisitView = lazy(() => import('../pages/visits/visitView/VisitView'));
const ProductList = lazy(
  () => import('../pages/products/productList/ProductList')
);
const ProductEdit = lazy(
  () => import('../pages/products/productEdit/ProductEdit')
);
const FolderEdit = lazy(
  () => import('../pages/products/productEdit/FolderEdit')
);
const CustomerList = lazy(
  () => import('../pages/customers/customerList/CustomerList')
);
const CustomerStatement = lazy(
  () => import('../pages/customers/customerStatement/CustomerStatement')
);
const CustomerEdit = lazy(
  () => import('../pages/customers/customerEdit/CustomerEdit')
);
const UserList = lazy(() => import('../pages/users/userList/UserList'));
const UserEdit = lazy(() => import('../pages/users/userEdit/UserEdit'));
const UserRouteList = lazy(
  () => import('../pages/users/userList/userRouteCustomers/UserRouteList')
);
const UserListCustomerTable = lazy(
  () =>
    import('../pages/users/userList/userRouteCustomers/UserListCustomerTable')
);
const UserListCustomerTableAddSection = lazy(
  () =>
    import('../pages/users/userList/userRouteCustomers/UserListCustomerTableAddSection')
);
const UserListCustomerDetails = lazy(
  () =>
    import('../pages/users/userList/userRouteCustomers/UserListCustomerDetails')
);
const DebitList = lazy(() => import('../pages/debits/debitList/DebitList'));
const DeviceList = lazy(() => import('../pages/devices/deviceList/DeviceList'));
const DeviceEdit = lazy(() => import('../pages/devices/deviceEdit/DeviceEdit'));
const BranchList = lazy(
  () => import('../pages/branches/branchList/BranchList')
);
const BranchEdit = lazy(
  () => import('../pages/branches/branchEdit/BranchEdit')
);
const AnalyticsOrders = lazy(
  () => import('../pages/analytics/orders/AnalyticsOrders')
);
const AnalyticsPayments = lazy(
  () => import('../pages/analytics/payments/AnalyticsPayments')
);
const AnalyticsCustomers = lazy(
  () => import('../pages/analytics/customers/AnalyticsCustomers')
);
const ManagerAnalytics = lazy(
  () => import('../pages/analytics/manager/ManagerAnalytics')
);
const ManagerAnalyticsDetail = lazy(
  () => import('../pages/analytics/manager/detail/ManagerAnalyticsDetail')
);
const Gps = lazy(() => import('../pages/gps/Gps'));
const GpsLive = lazy(() => import('../pages/gps/GpsLive'));
const InventoryList = lazy(
  () => import('../pages/inventory/inventoryList/InventoryList')
);
const InventoryEdit = lazy(
  () => import('../pages/inventory/inventoryEdit/InventoryEdit')
);
const InventoryQuantities = lazy(
  () => import('../pages/inventory/inventoryQuantity/InventoryQuantities')
);
const InventoryProductQuantitiesDetailsList = lazy(
  () =>
    import('../pages/inventory/inventoryProductQuantities/InventoryProductQuantitiesDetailsList')
);
const AccountSettings = lazy(() => import('../pages/settings/AccountSettings'));
const CompanySettings = lazy(() => import('../pages/settings/CompanySettings'));
const PasswordSettings = lazy(
  () => import('../pages/settings/PasswordSettings')
);
const GeneralSettings = lazy(() => import('../pages/settings/GeneralSettings'));
const PaymentTypeSettings = lazy(
  () => import('../pages/settings/PaymentTypeSettings')
);
const ProductSettings = lazy(() => import('../pages/settings/ProductSettings'));
const ImportXmlSettings = lazy(
  () => import('../pages/settings/ImportXmlSettings')
);
const NotificationSettings = lazy(
  () => import('../pages/settings/notificationSettings/NotificationSettings')
);
const ClearArchiveSettings = lazy(
  () => import('../pages/settings/clearArchiveSettings/ClearArchiveSettings')
);
const PackageSettings = lazy(
  () => import('../pages/settings/package/PackageSettings')
);
const ChangePackagePage = lazy(
  () => import('../pages/settings/package/ChangePackagePage')
);
const InventorySettings = lazy(
  () => import('../pages/settings/InventorySettings')
);
const StorageSettings = lazy(
  () => import('../pages/settings/storage/StorageSettings')
);
const ExportTemplatesList = lazy(
  () =>
    import('../pages/exportTemplates/exportTemplateList/ExportTemplatesList')
);
const ExportTemplatesEdit = lazy(
  () =>
    import('../pages/exportTemplates/exportTemplateEdit/ExportTemplatesEdit')
);
const ApiTokenList = lazy(
  () => import('../pages/apiToken/apiTokenList/ApiTokenList')
);
const ApiTokenEdit = lazy(
  () => import('../pages/apiToken/apiTokenEdit/ApiTokenEdit')
);
const UserProductsList = lazy(
  () => import('../pages/users/userList/userProducts/UserProductsList')
);
const FileManagerSettingsPage = lazy(
  () => import('../pages/settings/fileManager/FileManagerSettingsPage')
);

const AppRoute = () => {
  // const location = useLocation();

  // useEffect(() => {
  //   ConsoleLogActions.logObject("locationAppRoute", location);
  // }, [location]);

  const currentUserStatusClient = useSelector((state) => {
    return state.currentUser?.statusClient;
  });

  const lang = useSelector((state) => {
    return state.lang;
  });

  return (
    <Routes>
      <Route path="/:lang">
        <Route index element={<Navigate to="login" replace />} />
        <Route
          path="loginMagic/:_token"
          element={
            <BlankLayout>
              <LoginMagic />
            </BlankLayout>
          }
        />
        <Route
          path="arcaPayApiCheck/:_OrderNumber"
          element={
            <BlankLayout>
              <ArcaPayApiCheck />
            </BlankLayout>
          }
        />
        <Route
          path="activate/:_id"
          element={
            <BlankLayout>
              <UserEmailConfirm />
            </BlankLayout>
          }
        />
        <Route
          path="login"
          element={
            <LoadingProvider>
              <OutsideLayout isCenter>
                <Login />
              </OutsideLayout>
            </LoadingProvider>
          }
        />
        <Route
          path="registration"
          element={
            <LoadingProvider>
              <OutsideLayout isCenter>
                <RegistrationPage />
              </OutsideLayout>
            </LoadingProvider>
          }
        />
        <Route
          path="forgot_password"
          element={
            <LoadingProvider>
              <OutsideLayout isCenter>
                <ForgotPasswordPage />
              </OutsideLayout>
            </LoadingProvider>
          }
        />
        <Route
          path="forgot_password_set/:activationKey"
          element={
            <LoadingProvider>
              <OutsideLayout isCenter>
                <ForgotPasswordSetNewPassword />
              </OutsideLayout>
            </LoadingProvider>
          }
        />
        {currentUserStatusClient !== UserActions.STATUS.BLOCKED ? (
          <>
            <Route
              path="dashboard"
              element={
                <AppRoutePrivate>
                  <MainLayout fullPage>
                    <Dashboard />
                  </MainLayout>
                </AppRoutePrivate>
              }
            />
            <Route
              path="test"
              element={
                <AppRoutePrivate>
                  <MainLayout fullPage>
                    <Test />
                  </MainLayout>
                </AppRoutePrivate>
              }
            />
            <Route
              path="gps"
              element={
                <AppRoutePrivate>
                  <MainLayout fullPage>
                    <Gps />
                  </MainLayout>
                </AppRoutePrivate>
              }
            />
            <Route
              path="gps/live"
              element={
                <AppRoutePrivate>
                  <MainLayout fullPage>
                    <GpsLive />
                  </MainLayout>
                </AppRoutePrivate>
              }
            />
            <Route path="order">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <OrderList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="products"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <OrderProducts />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="view/:_idOrder"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <OrderView />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route path="payment">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <PaymentList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="view/:_idOrder"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <OrderView isPayment />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <PaymentEdit isNew />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idOrder"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <PaymentEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route path="visit">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <VisitList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="view/:_idManagerVisit"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <VisitView />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route path="product">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ProductList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ProductEdit isNew />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create/:_idParent"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ProductEdit isNew />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idProduct"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ProductEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="list/:_idParent"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ProductList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              {/* <Route
                path="quantities/:_idProduct"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryProductQuantitiesDetailsList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              /> */}
              <Route path="folder">
                <Route
                  path="create"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <FolderEdit isNew />
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="create/:_idParent"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <FolderEdit isNew />
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_idProduct"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <FolderEdit />
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
            </Route>
            <Route path="customer">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <CustomerList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="statement/:_idCustomer"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <CustomerStatement />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idCustomer"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <CustomerEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <CustomerEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route path="user">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <UserList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idUser"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <UserEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <UserEdit isNew />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="products/:_idManager"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <UserProductsList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route path="route">
                <Route path=":_idManager">
                  <Route
                    index
                    element={
                      <AppRoutePrivate>
                        <MainLayout fullPage>
                          <UserRouteList>
                            <UserListCustomerTable />
                          </UserRouteList>
                        </MainLayout>
                      </AppRoutePrivate>
                    }
                  />
                  <Route
                    path="add"
                    replace
                    element={
                      <AppRoutePrivate>
                        <MainLayout fullPage>
                          <UserRouteList>
                            <UserListCustomerTableAddSection />
                          </UserRouteList>
                        </MainLayout>
                      </AppRoutePrivate>
                    }
                  />
                  <Route
                    path=":_idRoute"
                    replace
                    element={
                      <AppRoutePrivate>
                        <MainLayout fullPage>
                          <UserRouteList>
                            <UserListCustomerTable />
                          </UserRouteList>
                        </MainLayout>
                      </AppRoutePrivate>
                    }
                  />
                  <Route
                    path=":_idRoute/add"
                    replace
                    element={
                      <AppRoutePrivate>
                        <MainLayout fullPage>
                          <UserRouteList>
                            <UserListCustomerTableAddSection />
                          </UserRouteList>
                        </MainLayout>
                      </AppRoutePrivate>
                    }
                  />
                </Route>
                <Route
                  path="customer/details/:_idManager/:_idCustomer"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout>
                        <UserListCustomerDetails />
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
            </Route>
            <Route
              path="debit/list"
              replace
              element={
                <AppRoutePrivate>
                  <MainLayout fullPage>
                    <DebitList />
                  </MainLayout>
                </AppRoutePrivate>
              }
            />
            {/* <Route path="device">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <DeviceList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idDevice"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <DeviceEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route> */}
            <Route path="inventory">
              <Route index element={<Navigate to="itemsList" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="create"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <InventoryEdit isNew />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_id"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <InventoryEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="itemsList/:_id"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryQuantities />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="itemsListDetails/:_idStore/:_idProduct"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryProductQuantitiesDetailsList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              {/* <Route
                path="quantity/import"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <InventoryQuantityImport />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              /> */}
              <Route
                path="quantity/import/orders"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryQuantityImport sourceType="ORDERS" />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="quantity/import/excel"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <InventoryQuantityImport sourceType="EXCEL" />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            {/* <Route path="branch">
              <Route index element={<Navigate to="list" replace />} />
              <Route
                path="list"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <BranchList />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="edit/:_idBranch"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout>
                      <BranchEdit />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route> */}
            <Route path="settings">
              <Route index element={<Navigate to="account" replace />} />
              <Route
                path="account"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <AccountSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="company"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <CompanySettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="password"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <PasswordSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="general"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <GeneralSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="payment"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <PaymentTypeSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="package"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout fullPage>
                        <PackageSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="package_change"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <ChangePackagePage />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="product"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <ProductSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="importxml"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <ImportXmlSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="clearArchive"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <ClearArchiveSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="inventory"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <InventorySettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="storage"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <StorageSettings />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="notification"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <NotificationSettings />
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route path="exportTemplates">
                <Route index element={<Navigate to="list" replace />} />
                <Route
                  path="list"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <ExportTemplatesList />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_id"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <ExportTemplatesEdit />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="create"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <ExportTemplatesEdit isNew />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
              <Route path="apikey">
                <Route index element={<Navigate to="list" replace />} />
                <Route
                  path="list"
                  replace
                  index
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <ApiTokenList />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="create"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <ApiTokenEdit isNew />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_id"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <ApiTokenEdit />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
              <Route path="devices">
                <Route index element={<Navigate to="list" replace />} />
                <Route
                  path="list"
                  replace
                  index
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <DeviceList />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_idDevice"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <DeviceEdit />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
              <Route path="branch">
                <Route index element={<Navigate to="list" replace />} />
                <Route
                  path="list"
                  replace
                  index
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <BranchList />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_idBranch"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <BranchEdit />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
              <Route path="policy">
                <Route index element={<Navigate to="list" replace />} />
                <Route
                  path="list"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout fullPage>
                          <PolicyList />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="edit/:_idPolicy"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <PolicyEdit />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
                <Route
                  path="create"
                  replace
                  element={
                    <AppRoutePrivate>
                      <MainLayout fullPage>
                        <SettingsLayout>
                          <PolicyEdit isNew />
                        </SettingsLayout>
                      </MainLayout>
                    </AppRoutePrivate>
                  }
                />
              </Route>
              <Route
                path="filemanager"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <SettingsLayout>
                        <FileManagerSettingsPage />
                      </SettingsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route path="analytics">
              <Route index element={<Navigate to="orders" replace />} />
              <Route
                path="orders"
                replace
                index
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <AnalyticsLayout fullPage>
                        <AnalyticsOrders />
                      </AnalyticsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="payments"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <AnalyticsLayout fullPage>
                        <AnalyticsPayments />
                      </AnalyticsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="customers"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <AnalyticsLayout fullPage>
                        <AnalyticsCustomers />
                      </AnalyticsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="manager"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <AnalyticsLayout fullPage>
                        <ManagerAnalytics />
                      </AnalyticsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
              <Route
                path="manager/:idManager"
                replace
                element={
                  <AppRoutePrivate>
                    <MainLayout fullPage>
                      <AnalyticsLayout fullPage>
                        <ManagerAnalyticsDetail />
                      </AnalyticsLayout>
                    </MainLayout>
                  </AppRoutePrivate>
                }
              />
            </Route>
            <Route
              path="home"
              element={<Navigate to={'dashboard'} replace />}
            />
            <Route path="*" element={<Navigate to={`/${lang}/dashboard`} />} />
          </>
        ) : (
          <>
            <Route
              path="test"
              element={
                <AppRoutePrivate>
                  <BlockedLayout fullPage>
                    <Test />
                  </BlockedLayout>
                </AppRoutePrivate>
              }
            />
            <Route
              path="buyApi"
              replace
              index
              element={
                <AppRoutePrivate>
                  <BlockedLayout fullPage>
                    <ChangePackagePage />
                  </BlockedLayout>
                </AppRoutePrivate>
              }
            />
            <Route
              path="notification"
              replace
              element={
                <AppRoutePrivate>
                  <BlockedLayout fullPage>
                    <NotificationSettings />
                  </BlockedLayout>
                </AppRoutePrivate>
              }
            />
            <Route path="*" element={<Navigate to={`/${lang}/buyApi`} />} />
          </>
        )}
      </Route>
      <Route path="payment">
        <Route
          path="idramfail"
          replace
          index
          element={
            // <AppRoutePrivate>
            <BlankLayout>
              <PayIdramFail />
            </BlankLayout>
            // </AppRoutePrivate>
          }
        />
        <Route
          path="idramsuccess"
          element={
            // <AppRoutePrivate>
            <BlankLayout>
              <PayIdramSuccess />
            </BlankLayout>
            // </AppRoutePrivate>
          }
        />
        <Route
          path="fail"
          replace
          index
          element={
            <AppRoutePrivate>
              <BlankLayout>
                <InvoicePaymentFail />
              </BlankLayout>
            </AppRoutePrivate>
          }
        />
        <Route
          path="success"
          element={
            <AppRoutePrivate>
              <BlankLayout>
                <InvoicePaymentSuccess />
              </BlankLayout>
            </AppRoutePrivate>
          }
        />
      </Route>
      {/* <Route path="page_not_found" element={<ErrorPage404 />} /> */}
      <Route path="/" index element={<Navigate to={'/en/login'} replace />} />
    </Routes>
  );
};

export default AppRoute;
